module.exports = __webpack_public_path__ + "img/icon-mail.a78c6f6b.svg";